import { render, staticRenderFns } from "./AuthTemplate.vue?vue&type=template&id=3b2f0ea2&scoped=true"
import script from "./AuthTemplate.vue?vue&type=script&lang=js"
export * from "./AuthTemplate.vue?vue&type=script&lang=js"
import style0 from "./AuthTemplate.vue?vue&type=style&index=0&id=3b2f0ea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2f0ea2",
  null
  
)

export default component.exports